var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAxNCI+CiAgICA8cGF0aAogICAgICAgICAgICBkPSJNMTksNi40MSwxNy41OSw1LDEyLDEwLjU5LDYuNDEsNSw1LDYuNDEsMTAuNTksMTIsNSwxNy41OSw2LjQxLDE5LDEyLDEzLjQxLDE3LjU5LDE5LDE5LDE3LjU5LDEzLjQxLDEyWiIKICAgICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUgLTUpIgogICAgICAgICAgICBmaWxsPSJjdXJyZW50Q29sb3IiCiAgICAvPgo8L3N2Zz4=";
export { SvgCrest as ReactComponent };